export class Cliente {
	public cdCliente = 0;
	public nmCliente = "";
	public cdFuncionario: number;
	public cdFilialCadastro: number;
	public cdTipoEntrega: number;
	public cnpjCpf: string;
	public nmFantasia: string;
	public tpDocFatura: string;
	public pcMarkup: number;
}
